module.exports = __webpack_public_path__ + "top.svg?34fdc14486f69bac9d84b6614153cb0b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top.svg
// module id = 395
// module chunks = 0